// extracted by mini-css-extract-plugin
export default {"container":"style_container__vIlBh","container__text":"style_container__text__HFj5m","container__error_button":"style_container__error_button__JG+fn"};